import React from 'react';
import {observer} from 'mobx-react';

import {useStores} from '../../stores/use-stores';

import PromotionsListScreenBase from './PromotionsListScreenBase';

const PromotionsListScreen = observer(() => {
  const {promotionsStore: activationsStore, shopSelectionStore} = useStores();

  let activations = activationsStore.promotions;
  if (shopSelectionStore.canPickup || shopSelectionStore.canDeliver) {
    activations = [
      ...activations,
      ...activationsStore.listedECommerceOnlyPromotions,
    ];
  }

  return <PromotionsListScreenBase promotions={activations} />;
});

export default PromotionsListScreen;
